export type GetIfItemListResponse = {
  /**
   * The results of this get_if_item response body.
   */
  ifItmGrpIfItmLkList: {
    ifItmNum: number;
    ifItmPhysclName: string;
    ifItmLgclName: string;
    ifItmGrpNum: number;
    ifItmGrpLgclName: string;
    ifItmGrpPhycslName: string;
  }[];
};
